import { takeEvery, takeLatest, call, put } from 'redux-saga/effects';
import { normalize } from 'normalizr';
import * as ActionTypes from '../actions/folders';
import * as Api from '../api/folders';
import * as Schema from '../api/schema';

function* fetchFolders() {
  try {
    const response = yield call(Api.fetch);
    yield put(
      ActionTypes.fetchFoldersSuccess(normalize(response, Schema.folders))
    );
  } catch (error) {
    yield put(ActionTypes.fetchFoldersFailure(error));
  }
}

function* saveFolder({ name }) {
  const response = yield call(Api.save, name);
  yield put(ActionTypes.saveFolderSuccess(normalize(response, Schema.folder)));
}

function* updateFolder({ folder }) {
  const response = yield call(Api.update, folder);
  yield put(
    ActionTypes.updateFolderSuccess(normalize(response, Schema.folder))
  );
}

function* removeFolder({ folder }) {
  yield call(Api.remove, folder.id);
  yield put(ActionTypes.removeFolderSuccess(folder.id));
}

export default function* root() {
  yield [
    takeLatest('FETCH_FOLDERS', fetchFolders),
    takeEvery('SAVE_FOLDER', saveFolder),
    takeEvery('UPDATE_FOLDER', updateFolder),
    takeEvery('REMOVE_FOLDER', removeFolder),
  ];
}



// WEBPACK FOOTER //
// ./src/modules/bucket/sagas/folders.js